export default "__VITE_ASSET__e4cd1728__"